import { render, staticRenderFns } from "./StoreProvinceStatistics.vue?vue&type=template&id=1f3bd231&scoped=true"
import script from "./StoreProvinceStatistics.vue?vue&type=script&lang=js"
export * from "./StoreProvinceStatistics.vue?vue&type=script&lang=js"
import style0 from "./StoreProvinceStatistics.vue?vue&type=style&index=0&id=1f3bd231&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f3bd231",
  null
  
)

export default component.exports